<template>
  <div id="login">
    <div class="row h-100 justify-content-center align-items-center">
      <form class="login-form forgot-password form" action="map.php" method="post">
        <h3 class="text-center brand">
          <img :src="config.logo.logo_icon_only" />
        </h3>
        <div class="form-group">
          <input
            type="text"
            v-model="state.user.username"
            name="email"
            id="username"
            class="form-control"
            :placeholder="i18n.app.common.username"
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            v-model="state.user.password"
            name="password"
            id="password"
            class="form-control"
            :placeholder="i18n.app.common.password"
          />
        </div>
        <div class="text-right forget-password">
          <a href="/forgot-password">{{ i18n.app.components.login.forgot_password }}</a>
        </div>
        <div class="form-group text-center">
          <button
            :disabled="state.loading"
            @click.prevent="onLoginPress"
            class="btn btn-default"
            :class="state.loading && 'load-spinner'"
          >
            <span>{{ i18n.app.components.login.login }}</span>
          </button>
        </div>
        <div class="text-center footer-brand">
          <img :src="config.logo.logo_white" style="filter:invert(1)" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dialogMixin from "@/mixins/dialog.mixin";

export default {
  data() {
    return {
      state: {
        loading: false,
        user: {
          username: "",
          password: ""
        }
      }
    };
  },
  mixins: [dialogMixin],
  methods: {
    onLoginPress() {
      this.state.loading = true;
      this._login({
        user: {
          ...this.state.user
        }
      })
        .then(state => {
          this._fetchUser().then(user => {
            if(user?.has_frontend_access){
              this.$router.push({ name: "home" });
            } else {
              this.$router.push({ name: "account" });
            }
          });
        })
        .catch(e => {
          this.showSimpleMessage(i18n.app.login.messages.incorrect_credentials);
        })
        .finally(() => (this.state.loading = false));
    },
    ...mapActions({
      _login: "login",
      _fetchUser: "fetchUser",
    })
  }
};
</script>
